import {
    LOAD_WHEEL_SPIN_DATA
} from '../../actions/app/wheel';

const initialState = {
    result: null
};

export default function reducer(state = initialState, action) {
    switch (action.type) {
        case LOAD_WHEEL_SPIN_DATA:
            return { ...state, result: action.payload.items };
        default:
            return state;
    }
}